import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { backendUrl } from "src/environments/environment";
import { toPromise } from "./toPromise";

export interface Ticket{
    title: String,
    description: String,
    type: number,
    img: String
}

@Injectable({
  providedIn: 'root',
})

export class TicketStore{
    constructor(private httpClient: HttpClient) {}

    async postTicket(params: Ticket): Promise<Ticket>{
        const url =`${backendUrl}ticket`;
        const token = localStorage.getItem('authToken')
        return toPromise(this.httpClient.post<Ticket>(url,params,{
            headers:new HttpHeaders({
                Authorization: `Bearer ${token}`,
            }),
        }));
    } 
}